const iconMap = {
    "01d": require("./assets/icons/01d.svg").default,
    "01n": require("./assets/icons/01n.svg").default,
    "02d": require("./assets/icons/02d.svg").default,
    "02n": require("./assets/icons/02n.svg").default,
    "03d": require("./assets/icons/03d.svg").default,
    "03n": require("./assets/icons/03n.svg").default,
    "04d": require("./assets/icons/04d.svg").default,
    "04n": require("./assets/icons/04n.svg").default,
    "09d": require("./assets/icons/09d.svg").default,
    "09n": require("./assets/icons/09n.svg").default,
    "10d": require("./assets/icons/10d.svg").default,
    "10n": require("./assets/icons/10n.svg").default,
    "11d": require("./assets/icons/11d.svg").default,
    "11n": require("./assets/icons/11n.svg").default,
    "13d": require("./assets/icons/13d.svg").default,
    "13n": require("./assets/icons/13n.svg").default,
    "50d": require("./assets/icons/50d.svg").default,
    "50n": require("./assets/icons/50n.svg").default,
};

export default iconMap;
